/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { AsnLinesService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { AsnLineStore } from './asn-line.store';
import {
    AsnLineCreate,
    AsnLineRead,
    AsnLineSearchParams,
} from '../../entities/asn-line.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class AsnLineDataService extends AbstractDataService<
    AsnLineRead,
    AsnLineCreate
> {
    protected EntityName = PFWmsEntities.AsnLine;
    constructor(
        private service: AsnLinesService,
        store: AsnLineStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        body: AsnLineCreate,
        asnHeaderId?: string
    ): Observable<AsnLineRead> {
        return this.service.asnLineCreate({
            asnHeaderId: asnHeaderId as string,
            asnLineViewModelCreateBody: body,
        }) as Observable<AsnLineRead>;
    }
    protected deleteObs$(
        id: string,
        asnHeaderId?: string
    ): Observable<AsnLineRead> {
        return this.service.asnLineDelete({
            id,
            asnHeaderId: asnHeaderId as string,
        }) as Observable<AsnLineRead>;
    }
    protected undoDeleteObs$(
        id: string,
        asnHeaderId?: string
    ): Observable<AsnLineRead> {
        return this.service.asnLineUndoDelete({
            id,
            asnHeaderId: asnHeaderId as string,
        }) as Observable<AsnLineRead>;
    }
    protected getObs$(
        id: string,
        asnHeaderId?: string
    ): Observable<AsnLineRead> {
        return this.service.asnLineReadById({
            id,
            asnHeaderId: asnHeaderId as string,
        }) as Observable<AsnLineRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[],
        _: AsnLineCreate,
        asnHeaderId?: string
    ): Observable<AsnLineRead> {
        return this.service.asnLineUpdatePatch({
            id,
            asnHeaderId: asnHeaderId as string,
            operation: operations,
        }) as Observable<AsnLineRead>;
    }
    protected searchObs$(
        searchParams: AsnLineSearchParams
    ): Observable<IPagedResult<AsnLineRead>> {
        return this.service.asnLineSearch(searchParams) as Observable<
            IPagedResult<AsnLineRead>
        >;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<IPagedResult<EntityChangeTrackingDto<AsnLineRead>>> {
        const { parentId, ...params } = searchParams;
        return this.service.asnLineGetChanges({
            ...params,
            asnHeaderId: parentId as string,
        }) as Observable<IPagedResult<EntityChangeTrackingDto<AsnLineRead>>>;
    }
}
